import { Drawer, Radio } from 'antd'
import ButtonCustom from '../../../../../Components/ButtonCustom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBacteria, faFloppyDisk, faXmark } from '@fortawesome/free-solid-svg-icons'
import { Render } from '../../../../../Components/CustomUi/render'
import Input from '../../../../../Components/CustomUi/input'
import TextArea from '../../../../../Components/CustomUi/textarea'
import Carregando from '../../../../../Components/CustomUi/loading'
import { Box } from '../../../../../Components/CustomUi/box'
import { Select } from '../../../../../Components/CustomUi/Select'
import { SetStateAction, useState } from 'react'

interface PropsFormularioMicrorganismos {
  nome: string
  setNome: React.Dispatch<React.SetStateAction<string>>
  bacteria_fungo: string
  setBacteria_fungo: React.Dispatch<React.SetStateAction<string>>
  setBacteria_fungo_id: React.Dispatch<React.SetStateAction<number>>
  editar: number
  openGaveta: boolean
  fecharGaveta: Function
  cadastrar: Function
  loadingSalvar: boolean
  loadingEditar: boolean
  data_tipo: any[]
}

const FormularioMicrorganismo: React.FC<PropsFormularioMicrorganismos> = ({
  nome,
  setNome,
  bacteria_fungo,
  setBacteria_fungo,
  setBacteria_fungo_id,
  editar,
  openGaveta,
  fecharGaveta,
  cadastrar,
  loadingSalvar,
  loadingEditar,
  data_tipo
}) => {
  const [open, setOpen] = useState<boolean>(false)

  return (
    <Drawer
      width={400}
      open={openGaveta}
      onClose={() => fecharGaveta()}
      closable={false}
      bodyStyle={{ padding: 0, overflowX: 'hidden' }}
      headerStyle={{ padding: '10px 10px' }}
      destroyOnClose
      title={
        <div style={{ display: 'flex', flexDirection: 'column', gap: 5, justifyContent: 'center' }}>
          <div
            style={{
              width: '100%',
              height: 35,
              borderBottom: 'thin solid var(--border-color)',
              marginLeft: -22,
            }}
          >
            <ButtonCustom
              onClick={fecharGaveta}
              type='tertiary'
              danger
              style={{ marginLeft: 10, marginTop: -10 }}
              icon={<FontAwesomeIcon icon={faXmark} />}
            >
              Fechar
            </ButtonCustom>
          </div>

          <>{editar ? 'Atualizar microrganismo' : 'Cadastrar microrganismo'}</>
        </div>
      }
      footer={
        <ButtonCustom
          disabled={loadingSalvar}
          loading={loadingSalvar}
          icon={<FontAwesomeIcon icon={faFloppyDisk} />}
          onClick={cadastrar}
        >
          {editar > 0 ? 'Atualizar' : 'Salvar'}
        </ButtonCustom>
      }
    >
      <Render condition={loadingEditar === false}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            padding: 10,
            gap: 10,
            boxSizing: 'border-box',
          }}
        >
          <Input
            label='Nome científico'
            placeholder={'Digite o nome do cargo'}
            value={nome}
            onChange={setNome}
          />
          <Select
            label='Tipo microrganismo'
            placeholder='Selecione o tipo microrganismo'
            value={bacteria_fungo}
            onChange={setBacteria_fungo}
            onChangeID={setBacteria_fungo_id}
            icon={faBacteria}
            open={open}
            trigger={setOpen}
            items={data_tipo}
            descricaoItem={'nome'}
            idItem={'cod'}
          />
        </div>
      </Render>
      <Render condition={loadingEditar}>
        <Carregando
          animation
          justifyContent='center'
          legenda='Carregando...'
          size={'default'}
          height={600}
        />
      </Render>
    </Drawer>
  )
}

export default FormularioMicrorganismo
